import { render, staticRenderFns } from "./popTipOfMessage.vue?vue&type=template&id=86db83b0"
import script from "./popTipOfMessage.vue?vue&type=script&lang=js"
export * from "./popTipOfMessage.vue?vue&type=script&lang=js"
import style0 from "./popTipOfMessage.vue?vue&type=style&index=0&id=86db83b0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports